import React from 'react';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';

const DARK_COLOR = '#444444';
const ACCENT_COLOR = '#fec35c';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 5000,
        padding: '1rem',
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '4px',
          maxWidth: '600px',
          width: '100%',
          maxHeight: '80vh',
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: '1.5rem 2rem',
            borderBottom: '1px solid rgba(229, 231, 235, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                backgroundColor: ACCENT_COLOR,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <FontAwesomeIcon
                icon={faFileAlt}
                style={{ color: 'white', width: 24, height: 24 }}
              />
            </div>
            <div>
              <h2
                style={{
                  fontSize: '1.125rem',
                  fontWeight: 600,
                  color: DARK_COLOR,
                  margin: 0,
                  fontFamily: 'Lato, system-ui, sans-serif',
                }}
              >
                Terms and Conditions
              </h2>
              <p
                style={{
                  fontSize: '0.75rem',
                  color: '#666',
                  margin: 0,
                  fontFamily: 'Lato, system-ui, sans-serif',
                }}
              >
                Please read carefully
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '0.5rem',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
            aria-label="Close"
          >
            <FontAwesomeIcon
              icon={faTimes}
              style={{ color: DARK_COLOR, width: 16, height: 16 }}
            />
          </button>
        </div>

        {/* Content */}
        <div
          style={{
            padding: '2rem',
            overflowY: 'auto',
            flex: 1,
          }}
        >
          <div
            style={{
              fontSize: '0.9375rem',
              color: DARK_COLOR,
              lineHeight: 1.7,
              fontFamily: 'Lato, system-ui, sans-serif',
            }}
          >
            <p style={{ marginBottom: '1rem' }}>
              Terms and conditions go here.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: '1rem 2rem',
            borderTop: '1px solid rgba(229, 231, 235, 0.5)',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: ACCENT_COLOR,
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '0.875rem',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              fontFamily: 'Lato, system-ui, sans-serif',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f16952';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = ACCENT_COLOR;
            }}
          >
            Got It
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TermsModal;
